<template>
  <div class="box box_v" style="height: 100%">
    <div class="mini-header-wrapper">
      <div class="left">
        <div class="iconfont icon-fanhui2" @click="$router.go(-1)"></div>
      </div>
      <div class="mini-header">模块设置</div>
      <div class="newvote">
        <Button v-if="!id" class="btn-dc" @click="setModule">保存</Button>
      </div>
    </div>
    <div class="item-wrapper box box_f1">
      <Card style="width: 100%;margin-right: 20px;margin-bottom: 20px">
        <div class="card-content box">
          <div class="box_f1">
            <!--标题-->
            <div class="i-title">
              <label class="i-label">标题</label>
              <div v-if="id">{{title}}</div>
              <Select v-else style="width:360px" v-model="serviceIndex" @on-change="selectService">
                <Option v-for="(item,index) in serviceList" :value="index">{{ item.label }}</Option>
              </Select>
            </div>
            <!--服务类型图标 -->
            <div class="i-title1">
              <label class="i-label" style="color:#999">图标</label>
              <img v-if="src" :src="src" alt/>
              <div v-else class="no-pic"></div>
            </div>
            <!--地图图标-->
            <div class="i-title">
              <label class="i-label ">
                地图图标
                <Tooltip content="社区管理->企业->地图及统计功能中本分类的企业在地图上的点位图标" placement="right">
                  <div class="tishi-icon">?</div>
                </Tooltip>
              </label>
              <div class="ditu-icon">
                <div v-if="dituIcon" class="dituicon-wrapper">
                  <img :src="dituIcon"/>
                </div>
                <div v-else class="no-ditiicon iconfont icon-tianjiajiahaowubiankuang"></div>
              </div>
            </div>
            <!--统计图颜色-->
            <div class="i-title box">
              <label class="i-label ">
                统计图颜色
                <Tooltip content="社区管理->企业->统计功能中本分类的柱状图颜色" placement="right">
                  <div class="tishi-icon">?</div>
                </Tooltip>
              </label>
              <ColorPicker v-model="color" disabled/>
            </div>
            <!--子模块-->
            <div class="i-title1 box">
              <label class="i-label ">子模块</label>
              <div>
                <div v-for="(item,index) in childList" class="box child-modal">
                  <Input v-model="item.value" style="width: 360px" disabled/>
                </div>
              </div>
            </div>
          </div>
          <div class="box_f1 box example">
            <div class="box" style="margin-right: 20px">示例</div>
            <div class="box_f1 eg-img">
              <div class="img">
                <img class="box" :src="src" alt/>
              </div>
              <p>{{title}}</p>
            </div>
          </div>
        </div>
      </Card>
    </div>
    <Spin fix size="large" v-if="saveLoading"></Spin>
  </div>
</template>

<script>
  export default {
    name: 'serviceSet',
    data() {
      return {
        id: '',//服务类型id
        title: "",//服务类型名字
        src: "",//服务类型图标
        dituIcon: '',//地图图标
        color: '',
        childList: [],
        serviceList: [],//查询的企业服务类型集合
        serviceIndex: '',
        serviceId: '',
        saveLoading: false,
      }
    },
    methods: {
      //获取企业服务类型列表
      getService() {
        var url = this.urlobj.dictionaryList('company_service_type')
        this.$get(url).then(res => {
          this.serviceList = res.rows.map(item => {
            return {
              label: item.dicName,
              id: item.id,
              headPicUrl: item.headPicUrl,
              color: JSON.parse(item.remark).color,
              dropUrl: JSON.parse(item.remark).drop_pic_url,
              childList: item.children.map(_item => {
                return {
                  value: _item.dicName
                }
              })
            }
          })
        })
      },
      // 选择服务类型  回显相关数据
      selectService(index) {
        var item = this.serviceList[index]
        this.title = item.label
        this.serviceId = item.id
        this.src = item.headPicUrl
        this.color = item.color
        this.dituIcon = item.dropUrl
        this.childList = item.childList
      },
      //保存
      setModule() {
        var url = this.urlobj.addService(this.serviceId)
        this.saveLoading = true
        this.$post(url).then(res => {
          this.saveLoading = false
          this.$Message.success('保存成功')
          setTimeout(() => {
            this.$router.go(-1)
          }, 1500)
        }).catch(e => {
          this.saveLoading = false
        })
      },
      //获取详情
      getDetail() {
        var url = this.urlobj.getTypeDetail(this.id);
        this.$get(url)
          .then(res => {
            var item = res.rows[0]
            this.title = item.title;
            this.src = item.iconUrl;
            this.dituIcon = item.dropUrl
            this.color = item.color16;
            this.childList = item.children.map(_item => {
              return {
                value: _item.title,
                id: _item.id
              }
            })
          })
          .catch(e => {

          });
      },
    },
    mounted() {
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.getDetail()
      } else {
        this.getService()
      }
    }
  }
</script>

<style scoped lang="less">
  .left {
    position: absolute;
    left: 20px;
    font-size: 22px;
    .iconfont {
      font-size: 26px;
      color: #999;
    }
  }

  .mini-header-wrapper {
    display: flex;
    /*height: 30px;*/
    line-height: 30px;
    padding: 30px 0;
    justify-content: center;
    position: relative;
  }

  .mini-header {
    font-size: 25px;
    text-align: center;
  }

  .item-wrapper {
    padding-left: 20px;
  }

  .newvote {
    position: absolute;
    right: 20px;
    button {
      width: 60px;
      height: 28px;
      line-height: 13px;
    }
  }

  .i-label {
    width: 90px;
    margin-right: 20px;
    white-space: nowrap;
    text-align: right;
    font-size: 14px;
    color: #666;
    /deep/ .ivu-tooltip-inner {
      max-width: 460px;
      background-color: #f4f4f4;
      color: #999
    }
    /deep/ .ivu-tooltip-arrow {
      left: 1px;
      border-width: 6px 6px 6px 0;
      border-right-color: #ebebeb;
    }
    .tishi-icon {
      color: #fff;
      background: #a8a9a9;
      height: 15px;
      width: 15px;
      line-height: 15px;
      text-align: center;
      border-radius: 50%;
      display: inline-block;
    }
  }

  .no-pic {
    width: 85px;
    height: 85px;
    border-radius: 50%;
    background: #efefef;
  }

  .i-input {
    flex: 1;
    position: relative;
    img {
      width: 85px;
      height: 85px;
      border-radius: 50%;
    }
    .icon {
      width: 85px;
      height: 85px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.3);
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
      .iconfont {
        font-size: 40px;
        line-height: 85px;
        color: #fff;
      }
    }
  }

  .i-title {
    display: flex;
    align-items: center;
    line-height: 1;
    margin-bottom: 15px;
  }

  .i-title1 {
    display: flex;
    margin-bottom: 15px;
    //   align-items: center;
  }

  .eg-img {
    height: 118px;
    max-width: 98px;
    border: 1px solid #dedede;
    border-radius: 2px;
    text-align: left;
    .img {
      margin: auto;
      width: 62px;
      height: 62px;
      margin-top: 18px;
      img {
        width: 62px;
        height: 62px;
        border-radius: 50%;
      }
    }
    p {
      margin-top: 10px;
      text-align: center;
    }
  }

  /deep/ .ivu-input {
    max-width: 360px;
  }

  .example {
    margin-left: -30%;
    margin-top: 5px;
  }

  .ditu-icon {
    .dituicon-wrapper {
      display: flex;
      height: 50px;
      width: 50px;
      border-radius: 50%;
      border: 1px solid #ececec;
      align-items: center;
      justify-content: center;
      img {
        height: 30px;
        width: 20px;
      }
    }
    .no-ditiicon {
      height: 50px;
      width: 50px;
      border-radius: 50%;
      border: 1px solid #ececec;
      text-align: center;
      color: #b0b0b0;
      font-size: 20px;
      line-height: 50px;
    }
  }

  .child-modal {
    margin-bottom: 10px;
    line-height: 1;
    align-items: center;
  }
</style>
